jQuery(window).load(function () {

    var e = jQuery;
    var $ = jQuery;

    // header scroll position
    var headerHeight = $('#nav-sticky').outerHeight();
    var lastScrollPostion = window.scrollY;
    var edge = 200;
    window.onscroll = function () {
        let scrollPosition = window.scrollY;
        const header = document.querySelector('#nav-sticky');
        // console.log('window.scrollY', window.scrollY)
        if (
            scrollPosition > headerHeight &&
            scrollPosition < lastScrollPostion &&
            scrollPosition < edge
        ) {
            header.classList.add('leaveSticky');
            header.classList.remove('enterSticky');
        } else if (scrollPosition >= edge) {
            header.classList.remove('leaveSticky');
            header.classList.add('enterSticky');
        } else {
            header.classList.remove('leaveSticky');
            header.classList.remove('enterSticky');
        }

        lastScrollPostion = scrollPosition;
    }

    $('.btn-outline-primary.btn-primary').removeClass('btn-primary');

    // menu dropdowns
    // e('.dropdown-toggle.nav-link').on('click', function (event) {
    //     console.log('CLICKEDDDDDDDDD')
    //     window.location = e(this).attr('href');
    // });
    // e('.dropdown-toggle.nav-link ~ span').on('click', function (event) {
    //     // console.log('arrow')
    //     // if (e(window).width() <= 768) {}
    //         if(e(this).hasClass('arrow-opened')){
    //             e(this).removeClass('arrow-opened');
    //             e('.dropdown-menu.show').removeClass('show');
    //         }else{
    //             e('.arrow-opened').removeClass('arrow-opened');
    //             e(this).addClass('arrow-opened');

    //             e('.dropdown-menu.show').removeClass('show');
    //             e(this).parent().find('.dropdown-menu').addClass('show');
    //         }

    //         event.preventDefault();
    //         event.stopPropagation();

    // });
    // e(window).resize(function() {
    //     if (e(window).width() >= 768) {
    //         e('.dropdown-menu.show').removeClass('show');
    //         e('.arrow-opened').removeClass('arrow-opened');
    //     }
    // });


    const popoverTriggerList = document.querySelectorAll('[href^="#g-term"]');
    let popups = [];
    function closeAllPopovers() {
        popups.forEach(popup => {
            if (popup.pop && popup.pop.tip) {
                popup.pop.hide();
            }
        });
    }
    const triggerArray = Array.from(popoverTriggerList);
    popups = triggerArray.map(popoverTriggerEl => {
        let pop;
        let term = popoverTriggerEl.getAttribute('href').split('#g-term');
        if (term[1]) {
            term = term[1].replace('-', '');
        } else {
            term = popoverTriggerEl.textContent.trim();
        }
        const glossaryEntry = glossaryData.find(item => item.term.toLowerCase().indexOf(term.toLowerCase()) !== -1);
        if (glossaryEntry) {
            pop = new understrap.Popover(popoverTriggerEl, {
                content: glossaryEntry.definition,
            });
            popoverTriggerEl.addEventListener('click', function (event) {
                event.preventDefault();
                pop.toggle();

                // Adjust popover position based on term's position
                // setTimeout(() => {
                // const popoverElement = pop.tip;
                // if (popoverElement) {
                //     const clickX = event.clientX;
                //     const clickY = event.clientY;
                //     // popoverElement.style.left = clickX;
                //     // popoverElement.style.top = clickY;
                //     popoverElement.style.transform = `translate(${clickX}px, ${clickY}px)`;
                //     // const rect = termElement.getBoundingClientRect();
                //     // termPositionX = e.clientX - rect.left;
                //     // termPositionY = e.clientY - rect.top;
                //     // popoverElement.style.left = termPositionX + 'px';
                //     // popoverElement.style.top = termPositionY + 'px';
                // }
                // }, 1000)
            });
        }
        return { el: popoverTriggerEl, entry: glossaryEntry, pop };
    });
    window.addEventListener('click', function (event) {
        closeAllPopovers();
    });


    const headerOffset = document.getElementById('main-nav').offsetHeight;
    function jumpTo(to) {
        const anchorElement = document.getElementById(to);
        if (anchorElement) {
            const elementOffset = anchorElement.offsetTop;
            let scrollPos = elementOffset
            if (window.innerWidth > 768) {
                scrollPos = elementOffset - headerOffset
            }
            window.scrollTo({
                top: scrollPos,
                behavior: 'smooth'
            });
        }
    }

    if ($('#map-block').length > 0) {
        // sites select tag
        const select = document.getElementById('sites-select');
        select && select.addEventListener('change', function () {
            const selectedValue = select.value;
            jumpTo(selectedValue);
        });

        var tooltipsRef;
        function setTooltipPosition($tt) {
            $tt && $tt.css({
                top: mouseY - $tt.height() - 20,
                left: mouseX - ($tt.width() / 2),
                position: 'absolute',
                opacity: 1
            });
        }
        var mouseX = 0;
        var mouseY = 0;
        $(document).mousemove(function (e) {
            mouseX = e.pageX;
            mouseY = e.pageY;
            setTooltipPosition(tooltipsRef);
        });
        // $('#FPMap0').imageMapResize();
        // $('#FPMap0 area').on('click', function (event) {
        //     var $this = $(this);
        //     var to = $this.attr('href').split('#')[1];
        //     jumpTo(to);
        //     event.preventDefault();
        // });
        // $('#FPMap0 area').hover(function (event) {
        //     var $this = $(this);
        //     // $('#FPMap0-hover polygon').attr('points', $this.attr('coords'));
        //     var $listings = $($this.attr('href')).find('.listing');
        //     var $tooltip = $('<div class="popover bs-popover-auto popover-tt map-popover" role="tooltip" data-popper-placement="top"><div class="arrow popover-arrow"></div><div class="popover-body"></div></div>');
        //     tooltipsRef && tooltipsRef.remove();
        //     tooltipsRef = $tooltip;
        //     $('body').append($tooltip);
        //     $tooltip.find('.popover-body').html('<div><strong>' + $listings.length + '</strong></div> Site in <br>' + ($this.attr('href').split('#')[1]));
        //     setTooltipPosition(tooltipsRef);
        // }, function () {
        //     tooltipsRef.remove();
        //     $('#FPMap0-hover polygon').attr('points', '');
        // });


        function addMap() {
            $('#map-alt #map-alt-wrap').remove();
            $('#map-alt').append('<div id="map-alt-wrap"></div>');
            $('#map-alt-wrap').width(Math.floor($('#map-alt').width()));
            $('#map-alt-wrap').height(window.innerWidth > 768 ? 400 : 340);

            setTimeout(function () {

                var statesWithSites = {};
                var stateSpecificHoverStyles = {};
                $('.states').each(function () {
                    var id = $(this).attr('id');
                    // console.log('id', id, $(this).attr('id'), $(this))
                    statesWithSites[id] = { fill: '#23408f' }
                    stateSpecificHoverStyles[id] = { fill: '#097a55' }
                });
                // console.log('statesWithSites', statesWithSites);

                $('#map-alt-wrap').usmap({
                    'stateStyles': {
                        fill: '#cdcdcd',
                        "stroke-width": 1,
                        'stroke': '#fff'
                    },
                    'stateHoverStyles': {
                        fill: '#aaa9a9'
                        // fill: '#097a55'
                    },
                    'stateSpecificStyles': statesWithSites,
                    stateSpecificHoverStyles: stateSpecificHoverStyles,
                    'labelBackingStyles': {
                        fill: "#666",
                        stroke: "#666",
                    },
                    'labelBackingHoverStyles': {
                        fill: '#939393',
                        stroke: "#939393"
                      },
                    stateSpecificLabelBackingStyles: statesWithSites,
                    stateSpecificLabelBackingHoverStyles: stateSpecificHoverStyles,
                    // {
                    //     'AK': { fill: '#23408f' }
                    // },

                    // 'mouseoverState': {
                    //     'HI': function (event, data) {
                    //         //return false;
                    //     }
                    // },
                    mouseout: function (event, data) {
                        tooltipsRef && tooltipsRef.remove();
                    },
                    'mouseover': function (event, data) {
                        //return false;
                        // console.log(data);

                        var $listings = $('#' + data.name).find('.listing');
                        var $tooltip = $('<div class="popover bs-popover-auto popover-tt map-popover" role="tooltip" data-popper-placement="top"><div class="arrow popover-arrow"></div><div class="popover-body"></div></div>');
                        tooltipsRef && tooltipsRef.remove();
                        tooltipsRef = $tooltip;
                        $('body').append($tooltip);
                        $tooltip.find('.popover-body').html('<div><strong>' + $listings.length + '</strong></div> in ' + data.name);
                        setTooltipPosition(tooltipsRef);
                    },


                    'click': function (event, data) {
                        jumpTo(data.name);
                    }
                });
            }, 10);
        }
        addMap();

        let resizeTimer;
        function handleResizeEnd() {
            addMap();
        }

        // Event listener for window resize
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(handleResizeEnd, 250); // Adjust the delay as needed (in milliseconds)
        });
    }

    // videos with play btn
    setTimeout(function () {
        var video = document.querySelector('.remove-overlaid presto-player');
        if (video) {
            var overlaidPlayBtn = video.shadowRoot.querySelector('.plyr__control.plyr__control--overlaid');
            overlaidPlayBtn.style.display = 'none';
        }
    }, 100);

    // videos pause on close
    var puOpen = document.querySelectorAll('.pum-trigger');
    var puClose = document.querySelectorAll('.pum-close');
    if (puOpen) {
        puOpen.forEach(function (puOpenBtn) {
            puOpenBtn.addEventListener("click", function () {
                lumPauseAllVideos();
            });
        });
    };
    if (puClose) {
        puClose.forEach(function (puCloseBtn) {
            puCloseBtn.addEventListener("click", function () {
                lumPauseAllVideos()
            });
        })
    };
});

// video setup
var lumPlayersObj = {};
var lumPlayersArr = [];
function lumPauseAllVideos() {
    console.log('lumPlayersObj', lumPlayersObj)
    for (var key in lumPlayersObj) {
        lumPlayersObj[key].pause();
    }
}
wp.hooks && wp.hooks.addAction("presto.playerReady", "my-plugin-namespace", function (player) {
    var idValue = player.id;
    lumPlayersObj[idValue] = player;
    lumPlayersArr.push(player);
});
